const AppId = {
  UserManagment: "1",
  Plan: "2",
  Transport: "3",
  Assignment: "4",
  Dashboard: "5"
}
const FilterOperator =
{
  Equals: 0,
  NotEquals: 1,
  GreaterThan: 2,
  GreaterOrEqual: 3,
  LessThan: 4,
  LessOrEqual: 5,
  Contains: 6
}
const RoomType =
{
  //زائر
  HousingAvailable: 0,
  //" ستاد کل نیروهای مسلح"
  GeneralStaffOfTheArmedForces: 1,
  //" بعثه آیات عظام"
  Themissionofgreatverses: 2,
  //"ستاد مدینه منوره"
  HeadquartersofMedinaMunorah: 3,
  //"جانبازان"
  veterans: 4,
  //"ستاد مکه مکرمه "
  Makkahheadquarters: 5,
  //" هواپیمایی"
  airline: 6,
  //" هیئت پزشکی"
  Medicalboard: 7,
  //" حمل و نقل درون شهری"
  IntraCityTransportation: 8,
  //"عوامل مجموعه "
  Collectionfactors: 9,
  //"بعثه مقام معظم رهبری"
  TheMissionOfTheSupremeLeader: 10,
  //" عوامل آشپزخانه مکه مکرمه "
  Makkahkitchenagents: 11,
  //" عوامل آشپزخانه مدینه منوره "
  KitchenstaffofMadinahManoorah: 12,

  //"محل کار ستاد "
  Headquartersworkplace: 13,
  //" محل کار بعثه"
  Themissionsworkplace: 14,
  //"خوابگاه ستاد"
  Headquartersdormitory: 15,
  //"خوابگاه بعثه"
  Baathehdormitory: 16,
  //" دفتر نمایندگی"
  representativeoffice: 17,
  //" در اختیار مالک"
  Atthedisposaloftheowner: 18,
  //"مطب پزشک"
  doctoroffice: 19,
  //" عوامل مجموعه های مدینه "
  AgentsofMedinacollections: 20,
  //"احتیاط"
  caution: 21,
  //"مدیر و روحانیون کاروان ها"
  Themanagerandclergyofthecaravans: 22,
  //" بعثه آیات"
  Themissionoftheverses: 23,
  //"دفتر بعثه آیات "
  TheOfficeoftheMissionofVerses: 24,
  //" کوتاه مدت "
  shortterm: 25,
  //" اساتید دانشگاه"
  Universityprofessors: 26,
  //"امداد گمشدگان"
  Thepencilofthelost: 27,
  //" ذابحین"
  slaughterers: 28,
  //" سفارت / کنسولی"
  EmbassyConsulate: 29,
  //" اساتید هیات علمی"
  Facultyprofessors: 30,
  //مدیر و معاون
  DeputyManagers: 31,
  //روحانی دو پلان
  clergyOfTwoPlans: 32,
  //" مدیران "
  Managers: 33,
  //" روحانیون"
  clergy: 34,
  //روحانی با معین
  clergyAndMoeen: 35,
  //مدیر و روحانی
  ManagerCleric: 36,
  //مدیران دو پلان
  ManagersOfTwoPlans: 37,
  //مدیر، معاون و روحانی
  DirectorDeputyCleric: 38,
  //مدیر ثابت
  FixedManager: 39,
  //مالک
  Owner: 40,
  //مازاد ظرفیت
  Over: 41
}
const AppLogicCode =
{
  //"پلان رزرو شده است"
  PlanIsBooked: 0,
  //Name = " پلان وجود ندارد"
  ThereIsNoPlan: 1,
  //Name = " گروه وجود ندارد"
  TheGroupDoesNotExist: 2,
  //Name = "درخواست رزرو تکراری "
  RecurringBookingRequest: 3
}
const ReserveEvent =
{
  Reserve: 0,
  Cancel: 1
}

const enumMapper = {
  AppId, FilterOperator, RoomType, AppLogicCode, ReserveEvent
}
export default enumMapper;